









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class DadosAnaliseSolicitacao extends Vue {
  @Prop({required: true, default: ""})
  observacoes!: string;
}
